import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmationHelperService } from '../services/confirmation-helper.service';
import type { PublicationDetailComponent } from '../components/pages/assets/analysis/publications/publication-detail.component';

const MESSAGE_KEY = 'entities.automaticPost.messages.editMode.unsavedNavigation';
const TITLE_KEY = 'entities.automaticPost.messages.editMode.unsavedTitle';
const SAVE_KEY = 'entities.automaticPost.messages.editMode.save';
// Short, single-line discard label ("Abandonner"); the dialog body carries the full context.
const QUIT_KEY = 'common.buttons.discard';

// Save / discard / stay (Escape). A successful save clears isDirty, so navigation
// only proceeds once the changes are persisted; a failed save keeps the user on the page.
export const publicationEditDirtyGuard: CanDeactivateFn<PublicationDetailComponent> = component => {
  if (!component.isDirty()) return true;
  const confirm = inject(ConfirmationHelperService);
  return confirm.askSaveDiscardCancel(MESSAGE_KEY, TITLE_KEY, SAVE_KEY, QUIT_KEY).then(async choice => {
    if (choice === 'cancel') return false;
    if (choice === 'discard') return true;
    try {
      await component.saveEdit();
    } catch {
      return false;
    }
    return !component.isDirty();
  });
};
